import { useTranslation } from 'react-i18next'

import { Box, Stack, Typography } from '@mui/material'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentSx,
  heroLeftSideContentSx,
  heroSubtitleSx,
  heroTitleSx,
  heroUnderlinedTitleSx,
  overlaySx,
} from './styles'

const HeroSection = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="tech-vendors-faq-hero-section" sx={containerSx}>
      <Box sx={contentSx}>
        <Stack sx={heroLeftSideContentSx}>
          <Typography component="h1" variant="h6" sx={heroUnderlinedTitleSx}>
            {t('Frequent Asked Questions')}
          </Typography>
          <TLGTypography
            responsiveVariant={{ xs: 'h5', md: 'h4' }}
            component="h2"
            sx={heroTitleSx}
          >
            {t('What can we help you find?')}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
            component="h2"
            sx={heroSubtitleSx}
          >
            {t(
              'Discover a variety of topics that could address any questions you may have about our Tech Vendor Solution.'
            )}
          </TLGTypography>
        </Stack>
      </Box>
      <Box sx={overlaySx} />
    </Box>
  )
}

export { HeroSection }
